import { Injectable } from '@angular/core';
import { CmpsDialog, CmpsDialogRef } from '@cmps/ng-uikit';

import { useStore } from '../../store.decorator';

import { TranscriptDialogData } from './model/transcript-dialog-data.model';
import { TranscriptDialogComponent } from './transcript-dialog.component';
import { transcriptDialogReducer } from './transcript-dialog.reducer';
import { TranscriptDialogState } from './transcript-dialog.state';

@Injectable({ providedIn: 'root' })
export class TranscriptDialogService {
    state: TranscriptDialogState;

    private _ref: CmpsDialogRef<TranscriptDialogComponent, void>;

    constructor(private readonly _dialog: CmpsDialog) {
        useStore(this, 'coaching.transcriptDialog', transcriptDialogReducer);
    }

    ngOnDestroy(): void {
        this.close();
    }

    open(transcriptId: number): void {
        this.close();

        const data: TranscriptDialogData = {
            transcriptId,
        };
        this._ref = this._dialog.open(TranscriptDialogComponent, {
            resizable: true,
            disableBackdrop: true,
            disableClose: true,
            movable: true,
            data,
        });
    }

    close(): void {
        this._ref?.close();
    }
}
